module.exports = __webpack_public_path__ + "img/partner-6.408ca6fc.png";